import { useDispatch } from "react-redux";
import { alertActions } from "../config/action-config";

export default function useCustomAlert () {
    const dispatch = useDispatch();

    const success = (message, onClose) => {
      dispatch({ type: alertActions.ALERT_SHOW, severity: "success", message, onClose })
    }
    
    const error = (message, onClose) => {
      dispatch({ type: alertActions.ALERT_SHOW, severity: "error", message, onClose })
    }
    
    const info = (message, onClose) => {
      dispatch({ type: alertActions.ALERT_SHOW, severity: "info", message, onClose })
    }
    
    const warning = (message, onClose) => {
      dispatch({ type: alertActions.ALERT_SHOW, severity: "warning", message, onClose })
    }
    
    const hide = () => {
      dispatch({ type: alertActions.ALERT_HIDE })
    }

    return { success, info, error, warning, hide }
}